"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.query = query;
exports.testWithOperator = testWithOperator;
exports["default"] = exports.operators = void 0;

var _lodash = require("lodash");

var isRegex = _lodash.isRegExp;
var equals = _lodash.eq;

var not_equals = function not_equals() {
  return !_lodash.eq.apply(void 0, arguments);
};

var neq = function neq() {
  return !_lodash.eq.apply(void 0, arguments);
};

var operators = {
  lt: _lodash.lt,
  gt: _lodash.gt,
  gte: _lodash.gte,
  lte: _lodash.lte,
  eq: _lodash.eq,
  neq: neq,
  equals: equals,
  not_equals: not_equals
  /**
   * Query an array using a parameters hash which allows for different operators,
   * and which can easily be serialized and sent over the wire
   *
   */

};
exports.operators = operators;

function query() {
  var nodeList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var params = arguments.length > 1 ? arguments[1] : undefined;
  var negate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  if (typeof nodeList.filter !== 'function') {
    return [];
  }

  if (typeof params === 'function') {
    return nodeList.filter(params);
  }

  var items = nodeList || [];
  return items.filter(function (node) {
    var matchesParam = Object.keys(params).every(function (key) {
      var param = params[key];
      var value = (0, _lodash.result)(node, key);

      if (isRegex(param) && param.test(value)) {
        return true;
      }

      if (typeof param === 'string' && value === param) {
        return true;
      }

      if (typeof param === 'number' && value === param) {
        return true;
      } // treat normal arrays to search for some exact matches


      if ((0, _lodash.isArray)(param) && ((0, _lodash.isString)(value) || (0, _lodash.isNumber)(value))) {
        return (0, _lodash.some)(param, function (val) {
          return val === value;
        });
      }

      if ((0, _lodash.isObject)(param) && (param.value || param.val) && (param.op || param.operator)) {
        return testWithOperator(param, value);
      }

      if ((0, _lodash.isObject)(param) && (0, _lodash.isObject)(value)) {
        return (0, _lodash.isMatch)(value, param);
      }
    });
    return negate ? !matchesParam : matchesParam;
  });
}

var _default = query;
exports["default"] = _default;

function testWithOperator(param, testValue) {
  var operator = param.operator || param.op;
  var checkValue = param.value || param.val;
  var testFn = operators[operator] || _lodash.isEqual;
  return testFn(testValue, checkValue);
}